/**
 * @file useFieldStatus.ts
 * @description Сообщить состояние общего поля конструктора наверх — в
 * заголовок группы настроек (✕ / !) (phase19.16, партия SB120; uiux-sb120-
 * fields §4, §5). Вызывается только когда тон или текст меняются; колбэк —
 * через ref: вызывающий может передавать новую функцию каждый рендер, это не
 * должно зацикливать.
 */

import { useEffect, useRef } from "react";

export interface FieldStatus {
  tone: "error" | "warning";
  text: string;
}

export function useFieldStatus(status: FieldStatus | null, onStatus: ((status: FieldStatus | null) => void) | undefined): void {
  const callback = useRef(onStatus);
  useEffect(() => {
    callback.current = onStatus;
  });
  const tone = status?.tone ?? null;
  const text = status?.text ?? null;
  useEffect(() => {
    callback.current?.(tone && text ? { tone, text } : null);
  }, [tone, text]);
}
